import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";
import "./ctaSection.scss";

function CTASectionList() {
  const navigate = useNavigate();
  const [ctaSections, setCtaSections] = useState([]);
  const breadcrumbItems = [
    { title: "CTA Sections", link: "#" },
    { title: "CTA Section List", link: "#" },
  ];

  useEffect(() => {
    fetchCTASections();
  }, []);

  const fetchCTASections = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/cta-section`);
      const data = await response.json();
      setCtaSections(data || []); // Updated here
    } catch (error) {
      console.error("Error fetching CTA sections:", error);
    }
  };

  const handleEdit = (ctaSection) => {
    navigate(`/edit-cta-section/${ctaSection._id}`, { state: { ctaSection } });
  };

  const handleDelete = async (ctaSectionId) => {
    if (window.confirm("Are you sure you want to delete this CTA section?")) {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/cta-section/${ctaSectionId}`,
          {
            method: "DELETE",
          }
        );
        if (response.ok) {
          setCtaSections(
            ctaSections.filter((cta) => cta._id !== ctaSectionId)
          );
        } else {
          console.error("Failed to delete CTA section");
        }
      } catch (error) {
        console.error("Error deleting CTA section:", error);
      }
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs
          title="CTA Section List"
          breadcrumbItems={breadcrumbItems}
        />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                {/* <div className="d-flex justify-content-end mb-4">
                  <Link to="/create-cta-section">
                    <Button color="primary">
                      <i className="ri-add-line align-middle me-1"></i> Add CTA
                      Section
                    </Button>
                  </Link>
                </div> */}

                <div className="table-responsive">
                  <Table className="table table-centered table-nowrap mb-0">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Title</th>
                        <th>Subtitle</th>
                        {/* <th>Button</th>
                        <th>Navigation URL</th> */}
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ctaSections.map((cta) => (
                        <tr key={cta._id} className="trending-category-row">
                          <td>{cta._id}</td>
                          <td>{cta.title}</td>
                          <td>{cta.subtitle}</td>
                          {/* <td>{cta.buttonName}</td>
                          <td>{cta.navigationUrl}</td> */}
                          <td>
                            <button
                              className="trending-category-action-buttons"
                              onClick={() => handleEdit(cta)}
                            >
                              <i className="ri-pencil-fill"></i>
                            </button>
                            {/* <button
                              className="trending-category-action-buttons"
                              onClick={() => handleDelete(cta._id)}
                            >
                              <i className="ri-delete-bin-fill"></i>
                            </button> */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CTASectionList;
